/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptDto } from '../../models/receipt-dto';

export interface ReceiptControllerDeleteNoScheduleReceipt$Params {
  id: string;
}

export function receiptControllerDeleteNoScheduleReceipt(http: HttpClient, rootUrl: string, params: ReceiptControllerDeleteNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerDeleteNoScheduleReceipt.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptDto>;
    })
  );
}

receiptControllerDeleteNoScheduleReceipt.PATH = '/api/receipt/normal/{id}';
